import { FLOATING_ELEMENT_PLACEMENT } from '../../../../../constants/common'
import { useContentOverflow } from '../../../../../hooks'
import { Divider } from '../../../../Divider'
import { FloatingTooltip } from '../../../../Floating'
import Text from '../../../../Text'

import * as styles from '../RequestProfileWidgetAddress.module.css'

function AddressContentItem({ label, multiline, value }) {
  const { overflow, setContentOverflowRef } = useContentOverflow()

  return (
    <>
      <Divider className={styles.divider} />
      <div className={styles.addressField}>
        <Text isSecondary className={styles.label}>
          {label}
        </Text>
        <FloatingTooltip
          content={value}
          disabled={!overflow}
          placement={FLOATING_ELEMENT_PLACEMENT.top}
        >
          <Text
            className={multiline ? styles.multilineValue : styles.value}
            ref={setContentOverflowRef}
          >
            {value}
          </Text>
        </FloatingTooltip>
      </div>
    </>
  )
}

export default AddressContentItem
